export type PlatformType = 'facebook' | 'instagram' | 'reddit';

export type RecommendationsData = {
	hasFacebookGroups: boolean;
	hasRedditGroups: boolean;
	isLoading: boolean;
};

export const ALL_AVAILABLE_PLATFORMS: PlatformType[] = ['facebook', 'instagram', 'reddit'];

export const PLATFORM_LABELS: Record<PlatformType, string> = {
	facebook: 'Facebook',
	instagram: 'Instagram',
	reddit: 'Reddit',
};

export function isPlatformType(value: string): value is PlatformType {
	return (ALL_AVAILABLE_PLATFORMS as string[]).includes(value);
}
